<div class="modal-header">
    <h4 class="modal-title pull-left mobile-title-handle">Auto Officer Compensation Calculation</h4>
    <button id="wizard-close-btn" type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<form #wizardForm="ngForm" novalidate="novalidate">
    <div class="modal-body">

        <div class="heading">
            Please select the owner who has the most responsibilities or could be considered the main owner
        </div>

        <div [ngClass]="{'has-warning':(ownerSelection.errors && (ownerSelection.dirty || ownerSelection.touched || wizardForm.submitted))}"
            class="form-group">
            <!--<div class="col-sm-12 select-arrow medium p-0">
                <select id="wizard-owner-salary-list" [(ngModel)]="selectedOwner" required #ownerSelection="ngModel" name="ownerSelection"
                    class="form-control" (ngModelChange)="mainOwnerChanged($event)">

                    <option [ngValue]="null" disabled selected hidden>Please select the owner</option>
                    <ng-container *ngFor="let owner of currentReport?.LATEST?.OWNERSHIP_LIST">
                        <option [ngValue]="owner" *ngIf="owner.HOURS > 0">{{reportService.checkStringWithTrim(owner.DISPLAY_NAME) ? owner.DISPLAY_NAME : owner.NAME}}</option>
                    </ng-container>
                </select>

                <small
                    *ngIf="ownerSelection.errors && (ownerSelection.dirty || ownerSelection.touched || wizardForm.submitted)"
                    class="color&#45;&#45;red">required</small>
            </div>-->

          <div class="col-sm-12 select-arrow medium p-0">
            <app-custom-select [(ngModel)]="selectedOwner" [values]="ownerList"
                               placeholder="Please select the owner" #ownerSelection="ngModel"
                               (ngModelChange)="mainOwnerChanged($event)"
                               name="wizard-owner-salary-list" id="wizard-owner-salary-list2">
            </app-custom-select>
          </div>
        </div>

        <!-- SCENARIO 2 && SCENARIO 3 -->
        <div class="row" *ngIf="(scenario === 2 || scenario === 3) && selectedOwner">
            <div class="col-md-12">
                <label *ngIf="scenario === 2">
                    <strong>{{reportService.checkStringWithTrim(selectedOwner.DISPLAY_NAME) ? selectedOwner.DISPLAY_NAME : selectedOwner.NAME}} </strong>
                    works {{selectedOwner.HOURS}} hours per week.<br />
                    Even though <strong>{{getSecondOwner().DISPLAY_NAME || getSecondOwner().NAME}}</strong> works {{getSecondOwner().HOURS}} hours per week,
                    a hypothetical replacement salary for <strong>{{getSecondOwner().DISPLAY_NAME || getSecondOwner().NAME}}</strong> should only be considered for
                    approximately
                    {{getApproxValue2nd()}} hours per week.
                    <div class="mt-2">
                        Based on this, what would the fair market replacement salary
                        for <strong>{{getSecondOwner().DISPLAY_NAME || getSecondOwner().NAME}}</strong> be?
                    </div>
                </label>
                <label *ngIf="scenario === 3">
                    <strong>{{getSecondOwner().DISPLAY_NAME || getSecondOwner().NAME}}</strong> works {{getSecondOwner().HOURS}} hours per week.
                    Based on this, what would the fair market replacement salary for <strong>{{getSecondOwner().DISPLAY_NAME || getSecondOwner().NAME}}</strong> be?
                </label>
            </div>

            <div class="col-md-12">

                <number-input [(ngModel)]="getSecondOwner().REPLACEMENT_SALARY_TEMP"
                    [classes]="'input input__large input__blue'"
                    #valueScen2_3="ngModel"
                    [required]="true"
                    [allowZero]="true"
                    [clearZero]="false"
                    name="valueScen2_3"
                    id="valueScen2_3"></number-input>

                <small class="color--red"
                    *ngIf="valueScen2_3.errors && (valueScen2_3.dirty || valueScen2_3.touched || wizardForm.submitted)"
                    style="right: 20px;">required</small>
            </div>
        </div>

        <!-- SCENARIO 4 -->
        <ng-container *ngIf="scenario === 4 && selectedOwner">

            <div class="row">
                <div class="col-sm-12">
                    <label class="text-center">
                        <strong>{{reportService.checkStringWithTrim(selectedOwner.DISPLAY_NAME) ? selectedOwner.DISPLAY_NAME : selectedOwner.NAME}}</strong>
                        works {{selectedOwner.HOURS}} hours per week.<br />
                        A full time working owner could work <strong><u>up to 50 hours a week</u></strong> and take over some of
                        the responsibilities of the other owners.
                        If applicable, who would this be <br />
                        <em>(choose all that apply without going over 50 hours a week combined)</em>?
                    </label>

                </div>
            </div>

            <div class="row my-3">
                <ng-container *ngFor="let owner of currentReport?.LATEST?.OWNERSHIP_LIST; let i=index;">
                    <div class="col-md-12" *ngIf="owner.ID != selectedOwner?.ID && owner.HOURS > 0">
                        <label class="checkbox large m-0"
                            [ngClass]="{'color--red': scenario4CheckboxDisabled(owner)}">
                            <input class="checkbox__input" type='checkbox' name="ownersList_{{i}}"
                                id="ownersListID_{{i}}" [value]="true" [checked]="owner.selected"
                                [(ngModel)]="owner.selected"
                                [disabled]="scenario4CheckboxDisabled(owner)"
                                (click)="ownerListClicked(scenario4CheckboxDisabled(owner))" />
                            <div class="checkbox__data">
                                <div class="checkbox__indicator"></div>
                                <p class="checkbox__text">
                                    <strong>{{reportService.checkStringWithTrim(owner.DISPLAY_NAME) ? owner.DISPLAY_NAME : owner.NAME}}</strong> works
                                    <strong>{{owner.HOURS}}</strong> hours per week
                                </p>
                            </div>
                        </label>
                    </div>
                </ng-container>
            </div>

            <div class="row my-3" *ngIf="showOverflow">
                <div class="col-md-12 text-center color--red">
                    You can not pick owners which make the combined hours over 50.
                </div>
            </div>

            <ng-container *ngFor="let owner of getFilteredOwnerSalary(); let i=index;">
                <div class="row mt-3" *ngIf="owner.ID != selectedOwner?.ID && owner.HOURS > 0 && !owner.selected">
                    <div class="col-md-12">
                        <label>
                            What is Fair Replacement Salary for <strong>{{reportService.checkStringWithTrim(owner.DISPLAY_NAME) ? owner.DISPLAY_NAME : owner.NAME}}</strong>
                        </label>
                    </div>

                    <div class="col-md-12">

                        <number-input [(ngModel)]="owner.REPLACEMENT_SALARY_TEMP"
                            [classes]="'input input__blue'"
                            #valueScen4="ngModel"
                            [required]="true"
                            [allowZero]="true"
                            [clearZero]="false"
                            name="repSalary_{{owner.ID}}"
                            id="repSalary_{{owner.ID}}"></number-input>

                        <small
                            *ngIf="valueScen4.errors && (valueScen4.dirty || valueScen4.touched || wizardForm.submitted)"
                            class="color--red" style="right: 20px;">required</small>
                    </div>
                </div>
            </ng-container>

        </ng-container>

        <!-- SCENARIO 5 -->
        <ng-container *ngIf="scenario === 5 && selectedOwner">
            <ng-container *ngFor="let owner of currentReport?.LATEST?.OWNERSHIP_LIST; let i = index;">
                <div class="form-group" *ngIf="owner.ID !== selectedOwner.ID && owner.HOURS > 0"
                    [ngClass]="{'has-warning':(valueScen5.errors && (valueScen5.dirty || valueScen5.touched || wizardForm.submitted))}">
                    <div class="col-sm-12">
                        <label class="control-label iv-label">
                            What is Fair Replacement Salary for <strong>{{reportService.checkStringWithTrim(owner.DISPLAY_NAME) ? owner.DISPLAY_NAME : owner.NAME}}</strong>
                        </label>
                    </div>

                    <div class="col-sm-12">

                        <number-input [(ngModel)]="owner.REPLACEMENT_SALARY_TEMP"
                            [classes]="'input input__large input__blue'"
                            #valueScen5="ngModel"
                            [required]="true"
                            [allowZero]="true"
                            [clearZero]="false"
                            name="negotRent_{{i}}"
                            id="negotRent_{{i}}"></number-input>

                        <span
                            *ngIf="valueScen5.errors && (valueScen5.dirty || valueScen5.touched || wizardForm.submitted)"
                            class="help-block" style="right: 20px;">required</span>
                    </div>
                </div>
            </ng-container>
        </ng-container>

    </div>

    <div class="modal-footer">
        <button id="wizard-owner-salary-close" type="button" class="button secondary__button large__button position-static"
            (click)="cancel()">Cancel</button>
        <button type="button" id="wizard-oner-salary-accept" class="button primary__button large__button position-static"
            [disabled]="!wizardForm.valid" (click)="onAccept()">Accept</button>
    </div>
</form>
